<template>
  <a id="Banner" class="Banner" :class="[showMobile?'showMobile':'' ]" href="https://itsjessicagrace.com/webinar" target="_blank">
    <div class="Banner__left">
        <img class="Banner__image" src="@/assets/banner/01/image.png" />
    </div>
    <div class="Banner__right">
        <img class="Banner__shake shake" src="@/assets/banner/01/prepa-success.jpg" />
    </div>
    <div class="Banner__hover">
        <div class="Banner__inner">
            <h1 class="Banner__text">  
                Use<div class="high pulse">PREPA</div><div class="small">(case sensitive)</div>for 25% OFF
            </h1>
        </div>
    </div>
  </a>
</template>

<script>
export default {
  data () {
    return {
      showMobile : false
    }
  },
  methods: {
    checkMobile () {
      if (typeof window.orientation !== 'undefined') { 
        this.showMobile = true
      }
    }
  },
  computed: {
    
  },
  watch : {
  },
  mounted () {
    this.checkMobile()
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600&display=swap');

h1, h2, h3, h4, p, div {
font-family: 'Poppins', sans-serif;
}

@media (min-width: 1045px) {
  .Banner {
      display: flex;
      border-radius: 10px;
      box-shadow: 0 0 30px 0 rgba(0, 0, 0, 0.08);
      background-color: #ffffff;
      position: relative;
      overflow: hidden;
      flex-direction: column-reverse;
      max-width: 240px;
      margin-left: 10px;
      pointer-events: all;
  }

  .Banner__left {
      width: 100%;
      position: relative;

  }
  .Banner__right {
      width: 100%;
      text-align: center;
      padding: 40px 0;
  }
}
@media (max-width: 1044px) {
  .Banner {
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 10px;
      box-shadow: 0 0 30px 0 rgba(0, 0, 0, 0.08);
      background-color: #ffffff;
      position: relative;
      overflow: hidden;
      pointer-events: all;
      margin-top: 40px;
  }

  .Banner__left {
      width: 40%;
      position: relative;

  }
  .Banner__right {
      width: 60%;
      text-align: center;
  }

}

.Banner__image {
    width: 100%;
    display: block;

}

.Banner__shake {
    display: block;
    width: 80%;
    margin: 0 auto;
}

.Banner__hover {
    opacity: 0;
    visibility: hidden;
    transition: all .3s ease-in;
    background: rgba(255, 255, 255, 0.8);
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    align-self: center;

}
.Banner:hover .Banner__hover {
    opacity: 1;
    top: 0;
    visibility: visible;
}

.shake {
    animation-name: shake;    
    animation-duration: 2s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
    transform-origin: 50% 100%;
}

.Banner:hover .shake {
  animation-play-state: paused;
}

.Banner__inner {
    text-align: center;
    width: 100%;
}

.Banner__text {
    color: #191340;
    line-height: 1.4;
    font-size: 24px;
    transition: all .3s ease-in .3s;
    transform: translateY(30px) scale(1.1);
    opacity: 0;
}
.Banner:hover .Banner__text {
    opacity: 1;
    visibility: visible;
    transform: translateY(0) scale(1);
}
.small {
    font-size: 14px;
}
.high {
    font-size: 32px;
}

.showMobile .Banner__hover {
    opacity: 1;
    bottom: 0;
    top: auto;
    visibility: visible;
    height: 20%;
}
.showMobile .Banner__text {
  opacity: 1;
  visibility: visible;
  transform: translateY(0) scale(1);
  font-size: 16px;
}
.showMobile .high {
    font-size: 16px;
    display: inline-block;
    margin: 0 3px;
}
.showMobile .small {
    margin: 0 3px;
    font-size: 10px;
    display: inline-block;
}

@keyframes shake {
  0%  { transform:     translate(2px, 1px) rotate(0deg); }
  10% { transform:     translate(-1px, -2px) rotate(-2deg); }
  20% { transform:     translate(-3px, 0px) rotate(3deg); }
  30% { transform:     translate(0px, 2px) rotate(0deg); }
  40% { transform:     translate(1px, -1px) rotate(1deg); }
  50% { transform:     translate(-1px, 2px) rotate(-1deg); }
  60% { transform:     translate(-3px, 1px) rotate(0deg); }
  70% { transform:     translate(2px, 1px) rotate(-2deg); }
  80% { transform:     translate(-1px, -1px) rotate(4deg); }
  90% { transform:     translate(2px, 2px) rotate(0deg); }
  100%{ transform:     translate(1px, -2px) rotate(-1deg); }
 }


@-webkit-keyframes pulse {
    from {
      -webkit-transform: scale3d(1, 1, 1);
              transform: scale3d(1, 1, 1);
    }
    50% {
      -webkit-transform: scale3d(1.05, 1.05, 1.05);
              transform: scale3d(1.05, 1.05, 1.05);
    }
    to {
      -webkit-transform: scale3d(1, 1, 1);
              transform: scale3d(1, 1, 1);
    }
  }

  @keyframes pulse {
    from {
      -webkit-transform: scale3d(1, 1, 1);
              transform: scale3d(1, 1, 1);
    }
    50% {
      -webkit-transform: scale3d(1.05, 1.05, 1.05);
              transform: scale3d(1.05, 1.05, 1.05);
    }
    to {
      -webkit-transform: scale3d(1, 1, 1);
              transform: scale3d(1, 1, 1);
    }
  }

  .showMobile .pulse {
    -webkit-animation: pulse ease-in-out 3s infinite 1s;
            animation: pulse ease-in-out 3s infinite 1s;
  }


</style>



// WEBPACK FOOTER //
// src/components/Banner/Banner.vue